import { execAdmin } from '@src/apis/reware/utils';

import type {
  StartPricingImportResult,
  StartPricingImportExecVariables,
  StartPricingImportExecResponse,
} from './types';

export interface StartPricingImportArgs {
  partnerId: number;
  pricingType: string;
}

/**
 * Start a pricing import session.
 * Creates a new PricingDiscount record and returns its ID.
 * Call addToPricingImport to add rules to this import.
 */
export const startPricingImport = async ({
  partnerId,
  pricingType,
}: StartPricingImportArgs): Promise<StartPricingImportResult> => {
  const query = `
    mutation startPricingImport(
      $partnerId: Int!
      $pricingType: String!
    ) {
      partner(id: $partnerId) {
        startPricingImport(pricingType: $pricingType) {
          pricingDiscountId
        }
      }
    }
  `;

  const data = await execAdmin<StartPricingImportExecVariables, StartPricingImportExecResponse>(
    query,
    { variables: { partnerId, pricingType } }
  );

  const result = data.partner?.startPricingImport;
  if (!result) {
    throw new Error(
      `startPricingImport: unexpected response — partner.startPricingImport is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId}, pricingType=${pricingType})`
    );
  }

  return result;
};
